module.exports = __webpack_public_path__ + "static/media/handbags.4af2468f.jpg";